import { useSplitTestBranch } from '@api/lendingAPI/lapiHooks';
import { getCountry } from '@iwIntlProvider/CountryProvider';

export const useUkDynamicDashboardSplitTest = () => {
    const isUK = getCountry() === 'UK';

    const { branch } = useSplitTestBranch({
        test: 'uk_dynamic_dashboard_2026',
        suspense: true,
        enabled: isUK
    });

    return {
        branch: branch as 'INCLUDE' | 'EXCLUDE' | undefined
    };
};
